import React from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableRow } from '@mui/material';
import StyledTableCell from 'components/SummaryComponent/StyledTableCell';
import { formatDate, getNextWeekDay, getWeeksAdded } from 'utils/date';

function CardCourseComponent(props) {
  const { course, dateParams } = props;

  const friday = 5;

  const getCourseEnd = (newCourseStart, weeks) =>
    getNextWeekDay(getWeeksAdded(newCourseStart, weeks - 1), friday);

  const courseEndDate = getCourseEnd(
    new Date(dateParams.courseStart),
    dateParams.courseWeeks
  );

  return (
    <TableBody>
      <TableRow>
        <StyledTableCell component="th" scope="row">
          Tipo de curso
        </StyledTableCell>
        <StyledTableCell align="right">
          {course.type} {course.title && <>- {course.title}</>}
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell component="th" scope="row">
          Carga horária
        </StyledTableCell>
        <StyledTableCell align="right">
          {course.period &&
            course.classesQuantity &&
            `${course.classesQuantity} - ${course.period}`}
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell component="th" scope="row">
          Data de início
        </StyledTableCell>
        <StyledTableCell align="right">
          {formatDate(dateParams.courseStart, 'forward-slash')}
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell component="th" scope="row">
          Data de término
        </StyledTableCell>
        <StyledTableCell align="right">
          {formatDate(courseEndDate, 'forward-slash')}
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell component="th" scope="row">
          Semanas
        </StyledTableCell>
        <StyledTableCell align="right">
          {dateParams.courseWeeks} Semanas
        </StyledTableCell>
      </TableRow>
    </TableBody>
  );
}

export default CardCourseComponent;

CardCourseComponent.propTypes = {
  course: PropTypes.instanceOf(Object).isRequired,
  dateParams: PropTypes.instanceOf(Object).isRequired,
};
